module.exports = __webpack_public_path__ + "img/dev_ipad.6e883c3d.webp";